<template>
  <div class="">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
    <h2 class="page-title">Approved Words</h2>
    <b-row>
      <b-col>
        <Widget
        >
          <div class="">
            <b-list-group>
              <b-list-group-item v-for="word in dictionary" class="d-flex justify-content-between align-items-center">
                {{word}}
                <a @click="removeWord(word)" v-b-tooltip.hover title="Remove"><i class="fa fa-trash" style="font-size:140%;color:gray"></i></a>
              </b-list-group-item>
            </b-list-group>

          </div>
          <p></p>
          <b-form inline @submit="addWord">
            <label class="sr-only" for="inline-form-input-name">Name</label>
            <b-input v-model="form.word"
                     id="inline-form-input-name"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="Approved Word"
            ></b-input>

            <b-button variant="primary" type="submit">Add Another</b-button>
          </b-form>
        </Widget>
      </b-col>
    </b-row>
    </div>
    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import axios from "axios";
  import gql from "graphql-tag";
  import { mapState } from 'vuex';
export default {
  name: 'Tables',
  components: { Widget },
  data() {
    return {
      loading: true,
      dataLoaded: false,
      dictionary: [],
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      form: {
        word: ''
      },
    };
  },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
            websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
              custom_dictionary
            }
          }`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {
          this.dictionary = data.data.websites_website[0].custom_dictionary.words;
          this.loading = false;
          this.dataLoaded = true;
        },

      },

    }
  },
  methods: {
    addWord(evt){
      evt.preventDefault()
      axios
              .put(`websites/${this.activeSite.id}/dictionary/${this.form.word}`)
              .then(
                      response => {
                        this.$toast.show('added to the dictionary', this.form.word, this.toastOptions);
                        this.form.word = '';
                        this.$root.$emit('global_reload');
                        return true;
                      },
                      _response => {
                        return false;
                      }
              );
    },
    removeWord(word){
       axios
              .delete(`websites/${this.activeSite.id}/dictionary/${word}`)
              .then(
                      response => {
                        this.$toast.show('removed from the dictionary', word, this.toastOptions);
                        this.$root.$emit('global_reload');
                        return true;
                      },
                      _response => {
                        return false;
                      }
              );
    }
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus"}),
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  mounted() {
  },
  created() {
    this.$root.$on('global_reload', () => {
      this.dataLoaded = false;
    });
  },
};
</script>

<style src="./Dictionary.scss" lang="scss" scoped />
